import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Modal from "../../../../components/Modals/Modal";
import { BtnGeneral } from "../../../../styles/Buttons";
import SearchableSelect from "../../../../components/Common/SearchableSelect";


// ==== ESTILOS ======================================================
const Input = styled.input`
  width: 100%;
  padding: 8px;
  margin-bottom: 12px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
`;

const Textarea = styled.textarea`
  width: 100%;
  padding: 8px;
  height: 80px;
  margin-bottom: 12px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
`;

const Row = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

// ==== COMPONENTE ===================================================
export default function ModalRole({ open, onClose, onSave, roleData }) {
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [estado, setEstado] = useState(1);

  // Setear valores cuando esté editando
  useEffect(() => {
    if (roleData) {
      setId(roleData.id ?? "");
      setName(roleData.name ?? "");
      setDesc(roleData.description ?? "");
      setEstado(roleData.status ?? 1);
    } else {
      setId("");
      setName("");
      setDesc("");
      setEstado(1);
    }
  }, [roleData]);

  if (!open) return null;

  return (
    <Modal isOpen={open} onClose={onClose} title={roleData ? "Editar Nivel" : "Nuevo Nivel"} width="400px">
          <>
        {roleData && (
          <>
            <label>ID:</label>
            <Input value={id} disabled />
          </>
        )}

        <label>Nombre:</label>
        <Input value={name} onChange={(e) => setName(e.target.value)} />

        <label>Descripción:</label>
        <Textarea value={desc} onChange={(e) => setDesc(e.target.value)} />

        <label style={{ fontSize: "12px", color: "#475569", fontWeight: "500", marginBottom: "4px", display: "block" }}>
          Estado:
        </label>
        <SearchableSelect
          value={String(estado ?? 1)}
          onValueChange={(val) => setEstado(Number(val))}
          options={[
            { value: "1", label: "Activo" },
            { value: "0", label: "Inactivo" },
          ]}
          placeholder="Seleccione estado..."
          multiple={false}
          searchable={false}
          size="small"
          sx={{
            mb: 2,
            "& .MuiOutlinedInput-root": {
              borderRadius: "6px",
              fontSize: "13px",
              fontFamily: "var(--font-body)",
              backgroundColor: "#ffffff",
              "& fieldset": { borderColor: "#cbd5e1" },
              "&:hover fieldset": { borderColor: "#94a3b8" },
              "&.Mui-focused fieldset": { borderColor: "#007bba" },
            },
            "& .MuiSelect-select": {
              padding: "7px 12px !important",
              fontSize: "13px",
              fontFamily: "var(--font-body)",
            },
          }}
        />

        <Row>
          <BtnGeneral bg="gray" padding="6px 14px" radius="6px" fs="12px" fw="500" onClick={onClose}>
            Cancelar
          </BtnGeneral>
          <BtnGeneral bg="blue" padding="6px 14px" radius="6px" fs="12px" fw="500" onClick={() => onSave({ id, name, description: desc, estado })}>
            Guardar
          </BtnGeneral>
        </Row>
    </>
    </Modal>
  );
}
